(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-addresses"] && !Shopify.designMode) return;
  try {
    
  // Addresses: open the slide-out with the right form, select each form's
  // country, "make default" submits that address's own form with the
  // default box ticked, delete asks for confirmation. A form that came back
  // with errors opens again on load.
  (function () {
    if (window.__addressesBound) return;
    window.__addressesBound = true;

    var lastFocus = null;

    function drawer() {
      return document.getElementById('addressDrawer');
    }

    function open(id) {
      var d = drawer();
      if (!d) return;
      var target = null;
      d.querySelectorAll('[data-address-form]').forEach(function (wrap) {
        var match = wrap.getAttribute('data-address-form') === String(id);
        wrap.hidden = !match;
        if (match) target = wrap;
      });
      if (!target) return;
      d.querySelector('#addressDrawerTitle').textContent = target.getAttribute('data-title');
      lastFocus = document.activeElement;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = target.querySelector('input:not([type="hidden"])');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 100);
    }

    function close() {
      var d = drawer();
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-address-open]');
      if (opener) {
        open(opener.getAttribute('data-address-open'));
        return;
      }
      if (e.target.closest('[data-address-close]')) {
        close();
        return;
      }
      var makeDefault = e.target.closest('[data-address-make-default]');
      if (makeDefault) {
        var wrap = document.querySelector('[data-address-form="' + makeDefault.getAttribute('data-address-make-default') + '"]');
        var form = wrap && wrap.querySelector('form');
        var box = form && form.querySelector('[data-address-default-input]');
        if (box) {
          box.checked = true;
          form.submit();
        }
      }
    });

    document.addEventListener('submit', function (e) {
      if (e.target.matches('[data-address-delete]') && !window.confirm('Wil je dit adres verwijderen?')) {
        e.preventDefault();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    function init() {
      document.querySelectorAll('select[data-default]').forEach(function (select) {
        var value = select.getAttribute('data-default');
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === value || select.options[i].text === value) {
            select.selectedIndex = i;
            break;
          }
        }
      });

      var errors = document.querySelector('[data-address-errors]');
      if (errors) {
        var wrap = errors.closest('[data-address-form]');
        if (wrap) open(wrap.getAttribute('data-address-form'));
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const hamburgerBtn = document.getElementById('hamburger-btn');
    const closeMenuBtn = document.getElementById('close-menu-btn');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const mobileMenuPanel = document.getElementById('mobile-menu-panel');
    const menuIcon = document.getElementById('menu-icon');
    const closeIcon = document.getElementById('close-icon');
    
    // Search panel: open/close + predictive search (Section Rendering API,
    // sections/predictive-search.liquid)
    const searchToggle = document.getElementById('searchToggle');
    const searchBar = document.getElementById('searchBar');
    const searchInput = document.getElementById('searchInput');

    if (searchToggle && searchBar && searchInput) {
      const searchResults = document.getElementById('predictive-search-results');
      const predictiveUrl = searchBar.getAttribute('data-predictive-url');
      const cache = new Map();
      let controller = null;
      let debounce = null;

      function openSearch() {
        searchBar.classList.add('active');
        searchToggle.setAttribute('aria-expanded', 'true');
        setTimeout(() => searchInput.focus(), 50);
      }

      function closeSearch(returnFocus) {
        if (!searchBar.classList.contains('active')) return;
        searchBar.classList.remove('active');
        searchToggle.setAttribute('aria-expanded', 'false');
        if (returnFocus) searchToggle.focus();
      }

      function showResults(html) {
        searchResults.innerHTML = html;
        const hasResults = html.trim() !== '';
        searchBar.classList.toggle('has-results', hasResults);
        searchInput.setAttribute('aria-expanded', hasResults ? 'true' : 'false');
      }

      function fetchResults(query) {
        if (cache.has(query)) {
          showResults(cache.get(query));
          return;
        }
        if (controller) controller.abort();
        controller = new AbortController();
        searchResults.classList.add('is-loading');
        const url = predictiveUrl
          + '?q=' + encodeURIComponent(query)
          + '&resources[type]=product,collection,page,query'
          + '&resources[limit]=4&resources[limit_scope]=each'
          + '&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const section = doc.querySelector('#shopify-section-predictive-search');
            const html = section ? section.innerHTML : '';
            cache.set(query, html);
            if (searchInput.value.trim() === query) showResults(html);
          })
          .catch(() => {})
          .finally(() => searchResults.classList.remove('is-loading'));
      }

      searchToggle.setAttribute('aria-expanded', 'false');
      searchToggle.setAttribute('aria-controls', 'searchBar');
      searchToggle.addEventListener('click', function() {
        if (searchBar.classList.contains('active')) closeSearch(false);
        else openSearch();
      });

      searchBar.querySelector('[data-search-close]').addEventListener('click', () => closeSearch(true));

      if (predictiveUrl) {
        searchInput.addEventListener('input', function() {
          const query = searchInput.value.trim();
          clearTimeout(debounce);
          if (query.length < 2) {
            if (controller) controller.abort();
            showResults('');
            return;
          }
          debounce = setTimeout(() => fetchResults(query), 250);
        });
      }

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeSearch(true);
      });

      // Close when clicking outside the panel (also the dimmed backdrop)
      document.addEventListener('click', function(e) {
        if (!searchBar.contains(e.target) && !searchToggle.contains(e.target)) {
          closeSearch(false);
        }
      });
    }

    // Desktop megamenu: opens on hover, click or keyboard; closes on leave,
    // Escape, focus moving out, or a click on the backdrop
    const desktopDropdowns = document.querySelectorAll('.nav-dropdown');
    const megamenuBackdrop = document.querySelector('.megamenu-backdrop');
    let dropdownTimeout = null;
    let hoverOpenedAt = 0;

    function setDropdown(dropdown, open) {
      dropdown.classList.toggle('active', open);
      const toggle = dropdown.querySelector('.nav-link-dropdown');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAllDropdowns() {
      clearTimeout(dropdownTimeout);
      desktopDropdowns.forEach(d => setDropdown(d, false));
    }

    desktopDropdowns.forEach(dropdown => {
      const toggle = dropdown.querySelector('.nav-link-dropdown');

      dropdown.addEventListener('mouseenter', function() {
        clearTimeout(dropdownTimeout);
        desktopDropdowns.forEach(d => { if (d !== dropdown) setDropdown(d, false); });
        if (!dropdown.classList.contains('active')) hoverOpenedAt = Date.now();
        setDropdown(dropdown, true);
      });

      dropdown.addEventListener('mouseleave', function() {
        dropdownTimeout = setTimeout(() => setDropdown(dropdown, false), 300);
      });

      if (toggle) {
        toggle.addEventListener('click', function() {
          // A mouse click right after hover opened it should keep it open
          if (Date.now() - hoverOpenedAt < 400) return;
          const open = !dropdown.classList.contains('active');
          closeAllDropdowns();
          setDropdown(dropdown, open);
        });
      }

      dropdown.addEventListener('focusout', function(e) {
        if (!dropdown.contains(e.relatedTarget)) setDropdown(dropdown, false);
      });
    });

    if (megamenuBackdrop) megamenuBackdrop.addEventListener('click', closeAllDropdowns);

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      const open = document.querySelector('.nav-dropdown.active');
      if (!open) return;
      closeAllDropdowns();
      const toggle = open.querySelector('.nav-link-dropdown');
      if (toggle) toggle.focus();
    });
    
    function toggleIcons(showClose) {
      if (showClose) {
        menuIcon.classList.remove('opacity-100', 'scale-100', 'rotate-0');
        menuIcon.classList.add('opacity-0', 'scale-0', '-rotate-90');
        closeIcon.classList.remove('opacity-0', 'scale-0', 'rotate-90');
        closeIcon.classList.add('opacity-100', 'scale-100', 'rotate-0');
      } else {
        menuIcon.classList.remove('opacity-0', 'scale-0', '-rotate-90');
        menuIcon.classList.add('opacity-100', 'scale-100', 'rotate-0');
        closeIcon.classList.remove('opacity-100', 'scale-100', 'rotate-0');
        closeIcon.classList.add('opacity-0', 'scale-0', 'rotate-90');
      }
    }
    
    function openMenu() {
      toggleIcons(true);
      mobileMenu.classList.remove('pointer-events-none');
      mobileMenu.setAttribute('aria-hidden', 'false');
      hamburgerBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      // Next frame, so the slide-in transition runs
      requestAnimationFrame(function() {
        mobileMenu.classList.add('is-open');
        closeMenuBtn.focus({ preventScroll: true });
      });
    }

    function closeMenu() {
      if (mobileMenu.classList.contains('pointer-events-none')) return;
      toggleIcons(false);
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      hamburgerBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function() {
        if (!mobileMenu.classList.contains('is-open')) mobileMenu.classList.add('pointer-events-none');
      }, 450);
      hamburgerBtn.focus({ preventScroll: true });
    }

    hamburgerBtn.addEventListener('click', function() {
      if (mobileMenu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) closeMenu();
    });

    closeMenuBtn.addEventListener('click', closeMenu);
    mobileMenuOverlay.addEventListener('click', closeMenu);
    
    const mobileDropdownToggles = document.querySelectorAll('.mobile-dropdown-toggle');
    mobileDropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const content = this.nextElementSibling;
        const chevron = this.querySelector('.mobile-chevron');
        
        const expanded = content.classList.toggle('expanded');
        chevron.classList.toggle('expanded', expanded);
        this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
    
    window.addEventListener('resize', function() {
      if (window.innerWidth >= 1024 && !mobileMenu.classList.contains('pointer-events-none')) {
        closeMenu();
      }
    });
  });

  // Header scroll behaviour (see .header-section in the stylesheet)
  (function() {
    function init() {
      const section = document.querySelector('.header-section');
      if (!section) return;
      const bar = document.getElementById('announcement-bar');
      const HIDE_AFTER = 100;
      let lastScrollY = window.scrollY;
      let ticking = false;

      // The bar is fluid, so keep its height in sync with the sticky offset.
      // --header-height (bar + nav) lets the homepage hero fill the screen.
      function syncBarHeight() {
        // Exact (fractional) height: offsetHeight rounds down and would leave
        // a sub-pixel strip of the banner above the pinned nav
        const height = bar && !bar.hidden ? bar.getBoundingClientRect().height : 0;
        const header = section.querySelector('header');
        const nav = section.querySelector('header nav');
        document.documentElement.style.setProperty('--announcement-height', height + 'px');
        if (header) document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
        if (nav) document.documentElement.style.setProperty('--nav-height', nav.offsetHeight + 'px');
      }
      syncBarHeight();
      if (window.ResizeObserver) {
        const ro = new ResizeObserver(syncBarHeight);
        if (bar) ro.observe(bar);
        const header = section.querySelector('header');
        if (header) ro.observe(header);
      }

      // A popup (menu, cart, filters) locks the page: keep the header put
      function isLocked() {
        return getComputedStyle(document.body).overflow === 'hidden';
      }

      function update() {
        const y = window.scrollY;
        if (isLocked()) {
          // leave it as it is
        } else if (y > lastScrollY && y > HIDE_AFTER) {
          if (!section.classList.contains('is-hidden')) {
            section.classList.add('is-hidden');
            armSolidWhenOut();
          }
          section.querySelectorAll('.nav-dropdown.active').forEach(d => {
            d.classList.remove('active');
            const toggle = d.querySelector('.nav-link-dropdown');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          });
        } else if (y < lastScrollY || y <= HIDE_AFTER) {
          section.classList.remove('is-hidden');
        }
        lastScrollY = y;
        ticking = false;
        syncState();
      }

      // Header look (see "Header states" in the stylesheet): solid while an
      // overlay is open, on pages without a hero, and on the homepage once
      // the header has been hidden by scrolling down (until back at the
      // top); otherwise transparent
      const hasHero = !!document.querySelector('[data-hero]');
      let solidArmed = false;
      let armTimer = null;

      // Turn white only once the slide-out has finished (transitionend on the
      // section's transform, 0.3s), so it never changes while still in view
      // and comes back white. 350ms fallback for when no transition runs.
      function armSolidWhenOut() {
        if (!hasHero || solidArmed) return;
        clearTimeout(armTimer);
        function arm() {
          section.removeEventListener('transitionend', onEnd);
          clearTimeout(armTimer);
          if (!section.classList.contains('is-hidden')) return;
          solidArmed = true;
          syncState();
        }
        function onEnd(e) {
          if (e.target === section && e.propertyName === 'transform') arm();
        }
        section.addEventListener('transitionend', onEnd);
        armTimer = setTimeout(arm, 350);
      }
      const searchBar = document.getElementById('searchBar');
      const mobileMenu = document.getElementById('mobile-menu');

      function syncState() {
        const overlayOpen =
          !!section.querySelector('.nav-dropdown.active') ||
          (searchBar && searchBar.classList.contains('active')) ||
          (mobileMenu && !mobileMenu.classList.contains('pointer-events-none'));
        const barHeight = bar && !bar.hidden ? bar.getBoundingClientRect().height : 0;
        // The banner is off screen (exact threshold); with no banner, any scroll
        const barGone = barHeight > 0 ? window.scrollY >= barHeight - 1 : window.scrollY > 0;
        section.classList.toggle('is-past-bar', barHeight > 0 && barGone);
        if (!barGone) solidArmed = false;
        const solid = overlayOpen || !hasHero || solidArmed;
        section.classList.toggle('is-solid', solid);
      }

      syncState();
      new MutationObserver(syncState).observe(section, { subtree: true, attributes: true, attributeFilter: ['class'] });

      // Dismiss the announcement and remember it for this message text
      const closeBanner = bar ? bar.querySelector('[data-announcement-close]') : null;
      if (closeBanner) {
        closeBanner.addEventListener('click', function() {
          try {
            localStorage.setItem('atelier-announcement-dismissed', bar.getAttribute('data-text'));
          } catch (e) {}

          // Collapse + fade (CSS), keeping the sticky offset and the hero in
          // step every frame, then hide it for good
          const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          let frame = null;
          function follow() {
            syncBarHeight();
            frame = requestAnimationFrame(follow);
          }
          function finish() {
            if (frame) cancelAnimationFrame(frame);
            bar.hidden = true;
            bar.classList.remove('is-closing');
            syncBarHeight();
            syncState();
          }

          if (reduce) {
            finish();
            return;
          }
          bar.classList.add('is-closing');
          follow();
          let done = false;
          bar.addEventListener('transitionend', function onEnd(e) {
            if (e.target !== bar || e.propertyName !== 'grid-template-rows' || done) return;
            done = true;
            bar.removeEventListener('transitionend', onEnd);
            finish();
          });
          // Safety net if transitionend never fires
          setTimeout(function () { if (!done) { done = true; finish(); } }, 700);
        });
      }

      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }, { passive: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero"]) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function escapeHtml(text) {
      return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // Split the title into its rendered lines: wrap each word, group words
    // by their offsetTop, then rebuild as masked lines.
    function splitLines(title) {
      var text = title.dataset.text || title.textContent.trim();
      title.dataset.text = text;
      title.innerHTML = text.split(/\s+/).map(function (w) {
        return '<span class="hero__word">' + escapeHtml(w) + '</span>';
      }).join(' ');

      var lines = [];
      var lastTop = null;
      title.querySelectorAll('.hero__word').forEach(function (word) {
        var top = word.offsetTop;
        if (lastTop === null || Math.abs(top - lastTop) > 2) {
          lines.push([]);
          lastTop = top;
        }
        lines[lines.length - 1].push(escapeHtml(word.textContent));
      });

      title.innerHTML = lines.map(function (line, i) {
        return '<span class="hero__line" aria-hidden="true"><span class="hero__line-inner" style="--line: ' + i + '">' + line.join(' ') + '</span></span>';
      }).join('');
      title.classList.add('is-split');
    }

    // Depth while scrolling: the photo drifts down inside the arch, the
    // product card drifts up, both scrubbed to the hero's scroll progress.
    function initDepth(hero) {
      var media = hero.querySelector('[data-hero-parallax]');
      var card = hero.querySelector('[data-hero-float]');
      var visible = true;
      var ticking = false;

      function update() {
        ticking = false;
        var rect = hero.getBoundingClientRect();
        var p = Math.min(1, Math.max(-1, -rect.top / rect.height));
        if (media) media.style.setProperty('--hero-shift', (p * 8).toFixed(2) + '%');
        if (card) card.style.setProperty('--hero-float', (p * -6).toFixed(2) + 'rem');
      }

      function onScroll() {
        if (!visible || ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) onScroll();
        }).observe(hero);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }

    function initHero(hero) {
      if (!hero || hero.dataset.heroInit) return;
      hero.dataset.heroInit = 'true';
      if (reduceMotion) return;

      var title = hero.querySelector('[data-hero-title]');
      var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
      fontsReady.then(function () {
        if (title) splitLines(title);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            hero.classList.add('is-revealed');
          });
        });
      });

      initDepth(hero);

      // Re-split on width changes so lines stay correct (no replay)
      var lastWidth = window.innerWidth;
      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth || !title) return;
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { splitLines(title); }, 200);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-hero]').forEach(initHero);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    document.addEventListener('shopify:section:load', function (event) {
      initHero(event.target.querySelector('[data-hero]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-latest-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (!root || root.dataset.sliderInit) return;
      root.dataset.sliderInit = 'true';
      var track = root.querySelector('[data-slider-track]');
      var thumb = root.querySelector('[data-slider-progress]');
      var prev = root.querySelector('[data-slider-prev]');
      var next = root.querySelector('[data-slider-next]');
      if (!track) return;

      function step() {
        var slide = track.firstElementChild;
        if (!slide) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var share = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        var pos = max > 0 ? track.scrollLeft / max : 0;
        if (thumb) {
          thumb.style.setProperty('--thumb-w', (share * 100).toFixed(2) + '%');
          thumb.style.setProperty('--thumb-x', (pos * (1 / share - 1) * 100).toFixed(2) + '%');
        }
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        root.classList.toggle('is-static', max <= 2);
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      // Drag to scroll with a mouse (touch and trackpads scroll natively)
      var startX = 0, startLeft = 0, moved = false, dragging = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startLeft = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) {
          moved = true;
          track.classList.add('is-dragging');
        }
        if (moved) track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false;
        if (moved) {
          // Re-enable snapping from where the drag ended
          var left = track.scrollLeft;
          track.classList.remove('is-dragging');
          track.scrollLeft = left;
          var s = step();
          track.scrollTo({ left: Math.round(left / s) * s, behavior: 'smooth' });
        }
      });

      update();
    }

    function initAll() {
      document.querySelectorAll('[data-product-slider]').forEach(initSlider);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function (e) {
      initSlider(e.target.querySelector('[data-product-slider]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-policy-content"] && !Shopify.designMode) return;
  try {
    
  // Policy pages: build the table of contents from the h2s in the content,
  // scroll smoothly (Lenis) to a heading and mark the part being read.
  (function () {
    function slugify(text) {
      return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function init() {
      var list = document.querySelector('[data-policy-toc]');
      var content = document.querySelector('[data-policy-content]');
      if (!list || !content || list.dataset.ready) return;
      list.dataset.ready = 'true';

      var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
      if (headings.length < 2) {
        list.closest('.policy__toc').hidden = true;
        return;
      }

      var used = {};
      var links = headings.map(function (heading) {
        if (!heading.id) {
          var id = slugify(heading.textContent) || 'deel';
          while (used[id] || document.getElementById(id)) id += '-2';
          heading.id = id;
        }
        used[heading.id] = true;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + heading.id;
        a.className = 'policy__toc-link';
        a.textContent = heading.textContent.trim();
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var offset = -(parseFloat(getComputedStyle(heading).scrollMarginTop) || 96);
          if (window.lenis) window.lenis.scrollTo(heading, { offset: offset });
          else heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(history.state, '', '#' + heading.id);
        });
        li.appendChild(a);
        list.appendChild(li);
        return a;
      });

      function setActive(index) {
        links.forEach(function (link, i) {
          link.classList.toggle('is-active', i === index);
        });
      }

      // The current part is the last heading above 30% of the viewport.
      // Read on scroll (Lenis scrolls the window too), so jumps and deep
      // links land on the right item as well.
      var ticking = false;
      function update() {
        ticking = false;
        var line = window.innerHeight * 0.3;
        var index = 0;
        headings.forEach(function (heading, i) {
          if (heading.getBoundingClientRect().top <= line) index = i;
        });
        setActive(index);
      }

      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(update);
        },
        { passive: true }
      );
      update();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-collection"]) return;
  try {
    
  // Collection page: sort select and the filter slide-out. Delegated on the
  // document, so it keeps working when the theme editor re-renders the
  // section.
  (function () {
    if (window.__collectionDrawerBound) return;
    window.__collectionDrawerBound = true;

    function parts() {
      var drawer = document.getElementById('filterDrawer');
      return {
        drawer: drawer,
        opener: document.querySelector('[data-filters-open]'),
        close: drawer ? drawer.querySelector('.filters__close') : null
      };
    }

    function isOpen() {
      var drawer = document.getElementById('filterDrawer');
      return !!drawer && drawer.classList.contains('is-open');
    }

    function setOpen(open) {
      var p = parts();
      if (!p.drawer) return;
      p.drawer.classList.remove('is-instant');
      p.drawer.classList.toggle('is-open', open);
      p.drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (p.opener) p.opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';

      if (open) {
        if (p.close) p.close.focus({ preventScroll: true });
      } else {
        if (p.opener) p.opener.focus({ preventScroll: true });
        // Opened after a filter reload: drop the flag once it is closed
        var url = new URL(window.location);
        if (url.searchParams.has('filters')) {
          url.searchParams.delete('filters');
          history.replaceState(history.state, '', url);
        }
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filters-open]')) {
        setOpen(true);
      } else if (e.target.closest('[data-filters-close]')) {
        setOpen(false);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) setOpen(false);
    });

    document.addEventListener('change', function (e) {
      if (e.target.id !== 'sort-by') return;
      var url = new URL(window.location);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      url.searchParams.delete('filters');
      window.location = url.toString();
    });

    // Never leave the page locked when the editor swaps the section out
    document.addEventListener('shopify:section:unload', function () {
      if (isOpen()) document.body.style.overflow = '';
    });

    // Reopened after a filter reload: sync the button state, but leave focus
    // where the browser put it (no focus ring on the close button)
    function syncReopened() {
      var p = parts();
      if (!p.drawer || !isOpen()) return;
      if (p.opener) p.opener.setAttribute('aria-expanded', 'true');
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncReopened);
    else syncReopened();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-product"]) return;
  try {
    
  // Product page: options -> variant (matched on option1..3), price, stock,
  // add button, ?variant= in the URL and the variant's photo; the photo
  // slider (arrows, thumbnails, swipe, counter); the quantity stepper; gift card amount and
  // recipient fields; the floating add bar. The form stays a plain /cart/add form, the global
  // handler in add-to-cart.liquid posts it and opens the cart drawer.
  (function () {
    function formatMoney(cents, trimZeros) {
      var value = (cents / 100).toFixed(2).replace('.', ',');
      if (trimZeros) value = value.replace(/,00$/, '');
      return '€' + value;
    }

    function initProduct(section) {
      if (!section || section.dataset.ready) return;
      var json = section.querySelector('[data-product-variants]');
      if (!json) return;
      section.dataset.ready = 'true';

      var variants = JSON.parse(json.textContent);
      var idInput = section.querySelector('#variantId');
      var price = section.querySelector('[data-product-price]');
      var compare = section.querySelector('[data-product-compare]');
      var addBtn = section.querySelector('#addToCartBtn');
      var stock = section.querySelector('[data-product-stock]');
      var bar = section.querySelector('[data-product-bar]');
      var barAdd = section.querySelector('[data-bar-add]');
      var barChoose = section.querySelector('[data-bar-choose]');
      var barPrice = section.querySelector('[data-bar-price]');
      var barVariant = section.querySelector('[data-bar-variant]');
      var giftAmount = section.querySelector('[data-giftcard-amount]');
      var gallery = section.querySelector('[data-product-gallery]');
      var fieldsets = Array.prototype.slice.call(section.querySelectorAll('[data-option-position]'));

      function selectedOptions() {
        var selected = {};
        fieldsets.forEach(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          if (checked) selected[fieldset.getAttribute('data-option-position')] = checked.value;
        });
        return selected;
      }

      function findVariant(selected) {
        return variants.find(function (v) {
          return Object.keys(selected).every(function (position) {
            return v['option' + position] === selected[position];
          });
        });
      }

      // Strike out values that have no available variant with the other choices
      function markAvailability(selected) {
        fieldsets.forEach(function (fieldset) {
          var position = fieldset.getAttribute('data-option-position');
          fieldset.querySelectorAll('input').forEach(function (input) {
            var test = Object.assign({}, selected);
            test[position] = input.value;
            var match = findVariant(test);
            input.classList.toggle('is-unavailable', !match || !match.available);
          });
        });
      }

      // Gallery slider: one photo per view, driven by scroll-snap so touch,
      // trackpad, arrows and thumbnails all share one position.
      var slides = gallery ? Array.prototype.slice.call(gallery.children) : [];
      var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-thumb]'));
      var counter = section.querySelector('[data-gallery-current]');
      var prev = section.querySelector('[data-gallery-prev]');
      var next = section.querySelector('[data-gallery-next]');
      var current = 0;

      function goTo(index) {
        if (!slides.length) return;
        index = Math.max(0, Math.min(slides.length - 1, index));
        var left = slides[index].offsetLeft - slides[0].offsetLeft;
        gallery.scrollTo({ left: left, behavior: 'smooth' });
      }

      function setCurrent(index) {
        current = index;
        if (counter) counter.textContent = index + 1;
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
        });
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
      }

      if (gallery && slides.length > 1) {
        var ticking = false;
        gallery.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              ticking = false;
              var step = slides[1].offsetLeft - slides[0].offsetLeft;
              setCurrent(Math.min(slides.length - 1, Math.round(gallery.scrollLeft / step)));
            });
          },
          { passive: true }
        );
        if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
        if (next) next.addEventListener('click', function () { goTo(current + 1); });
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            goTo(parseInt(thumb.getAttribute('data-gallery-thumb'), 10));
          });
        });
        gallery.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        });
        setCurrent(0);
      }

      function showImage(variant) {
        if (!gallery || !variant.featured_image) return;
        var slide = gallery.querySelector('[data-media-id="' + variant.featured_image.id + '"]');
        if (slide) goTo(slides.indexOf(slide));
      }

      function update(fromUser) {
        var selected = selectedOptions();
        var variant = findVariant(selected);
        markAvailability(selected);

        fieldsets.forEach(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          var label = fieldset.querySelector('[data-option-selected]');
          if (checked && label) label.textContent = checked.value.replace(/,00$/, '');
        });

        if (!variant) {
          addBtn.disabled = true;
          addBtn.textContent = 'Niet beschikbaar';
          return;
        }

        idInput.value = variant.id;
        price.textContent = formatMoney(variant.price, !!giftAmount);
        if (giftAmount) giftAmount.textContent = formatMoney(variant.price, true);
        if (compare) {
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          compare.hidden = !onSale;
          if (onSale) compare.textContent = formatMoney(variant.compare_at_price);
        }

        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Toevoegen aan winkelwagen' : 'Uitverkocht';
        if (stock) stock.hidden = variant.available;

        if (barAdd) {
          barAdd.disabled = !variant.available;
          barAdd.textContent = variant.available ? 'In winkelwagen' : 'Uitverkocht';
        }
        if (barPrice) barPrice.textContent = formatMoney(variant.price, !!giftAmount);
        if (barVariant) barVariant.textContent = variant.title.replace(/,00$/, '');

        if (fromUser) {
          var url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          history.replaceState(history.state, '', url);
          showImage(variant);
        }
      }

      fieldsets.forEach(function (fieldset) {
        fieldset.addEventListener('change', function () {
          update(true);
        });
      });

      // Quantity stepper
      var qty = section.querySelector('#quantity');
      section.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = (parseInt(qty.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10);
          qty.value = Math.max(1, next);
        });
      });

      // Short confirmation on the button after a successful add
      document.addEventListener('cart:updated', function () {
        if (!document.body.contains(addBtn) || addBtn.disabled) return;
        addBtn.textContent = 'Toegevoegd';
        if (barAdd) barAdd.textContent = 'Toegevoegd';
        setTimeout(function () {
          update(false);
        }, 1800);
      });

      // Gift card: recipient fields only count when the box is ticked
      var toggle = section.querySelector('[data-giftcard-toggle]');
      var fields = section.querySelector('[data-giftcard-fields]');
      if (toggle && fields) {
        var date = fields.querySelector('[data-giftcard-date]');
        var offset = fields.querySelector('[data-giftcard-offset]');
        if (date) {
          var max = new Date();
          max.setDate(max.getDate() + 90);
          date.min = new Date().toISOString().slice(0, 10);
          date.max = max.toISOString().slice(0, 10);
        }
        if (offset) offset.value = new Date().getTimezoneOffset();

        toggle.addEventListener('change', function () {
          fields.hidden = !toggle.checked;
          fields.querySelectorAll('input, textarea').forEach(function (el) {
            el.disabled = !toggle.checked;
          });
        });
      }

      // Floating bar: shown while the add button is above the viewport and
      // the footer is not yet in view. Read from the real positions on every
      // scroll frame (an IntersectionObserver misses jumps from below the
      // button to above it, since it is out of view in both).
      if (bar) {
        var footer = document.querySelector('.site-footer');
        var barTicking = false;

        function syncBar() {
          barTicking = false;
          var buttonAbove = addBtn.getBoundingClientRect().bottom < 0;
          var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
          var show = buttonAbove && !footerVisible;
          if (show === bar.classList.contains('is-visible')) return;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (barAdd) barAdd.tabIndex = show ? 0 : -1;
          if (barChoose) barChoose.tabIndex = show ? 0 : -1;
        }

        window.addEventListener(
          'scroll',
          function () {
            if (barTicking) return;
            barTicking = true;
            requestAnimationFrame(syncBar);
          },
          { passive: true }
        );
        window.addEventListener('resize', syncBar);
        syncBar();

        // With variants: back up to the options, focus on the chosen value
        if (barChoose) {
          barChoose.addEventListener('click', function () {
            var options = section.querySelector('.product__options');
            if (!options) return;
            var offset = -((parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nav-height')) || 72) + 24);
            if (window.lenis) window.lenis.scrollTo(options, { offset: offset });
            else window.scrollTo({ top: options.getBoundingClientRect().top + window.scrollY + offset, behavior: 'smooth' });
            var checked = options.querySelector('input:checked') || options.querySelector('input');
            if (checked) setTimeout(function () { checked.focus({ preventScroll: true }); }, 700);
          });
        }
      }

      update(false);
    }

    function initAll() {
      document.querySelectorAll('[data-product-section]').forEach(initProduct);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-workshops"] && !Shopify.designMode) return;
  try {
    
  // Workshops page: a date in the panel (or the "Schrijf je in" button)
  // scrolls to the registration form; a date also selects itself in the
  // form's dropdown. Delegated, so it survives theme editor reloads.
  (function () {
    if (window.__workshopDatesBound) return;
    window.__workshopDatesBound = true;

    function scrollToForm() {
      var target = document.getElementById('aanvraag');
      if (!target) return false;
      if (window.lenis) window.lenis.scrollTo(target, { offset: -24 });
      else target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }

    document.addEventListener('click', function (e) {
      var dateBtn = e.target.closest('[data-workshop-date]');
      var link = e.target.closest('[data-workshop-scroll]');
      if (!dateBtn && !link) return;

      if (dateBtn) {
        var select = document.getElementById('workshop-date');
        var value = dateBtn.getAttribute('data-workshop-date');
        if (select) {
          for (var i = 0; i < select.options.length; i++) {
            if (select.options[i].value === value) {
              select.selectedIndex = i;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }
      }

      if (scrollToForm()) {
        e.preventDefault();
        var first = document.getElementById('first-name');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 900);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
